import React from 'react';
import Select from 'react-select';
import makeAnimated from "react-select/animated";
import { useTheme } from "@mui/material/styles";


const StyledMultiSelect = ({onChange, options, value, id, name, placeholder}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const selectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: isDark ? '#2b2b2b' : '#fff',
      borderColor: isDark ? '#555' : '#ccc',
      color: isDark ? '#fff' : '#555',
      '&:hover': { borderColor: isDark ? '#888' : '#aaa' },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: isDark ? '#2b2b2b' : '#fff',
      zIndex: 9999,
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? theme.palette.primary.main
        : isFocused
        ? isDark ? '#3a3a3a' : '#f0f0f0'
        : isDark ? '#2b2b2b' : '#fff',
      color: isSelected ? '#fff' : isDark ? '#e0e0e0' : '#333',
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: isDark ? '#444' : '#e0e0e0',
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: isDark ? '#e0e0e0' : '#333',
    }),
    multiValueRemove: (base) => ({
      ...base,
      color: isDark ? '#aaa' : '#666',
      '&:hover': { backgroundColor: isDark ? '#666' : '#ccc', color: '#fff' },
    }),
    input: (base) => ({
      ...base,
      color: isDark ? '#fff' : '#333',
    }),
    placeholder: (base) => ({
      ...base,
      color: isDark ? '#888' : '#aaa',
    }),
    singleValue: (base) => ({
      ...base,
      color: isDark ? '#e0e0e0' : '#333',
    }),
  };

  return (
    <Select
      components={makeAnimated}
      isMulti
      options={options}
      value={value}
      id={id}
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      styles={selectStyles}
    />
  );
};

export {StyledMultiSelect};

